import React from "react";
import { colors, radius } from "./tokens";

type Variant = "primary" | "secondary" | "danger" | "ghost";

const VARIANTS: Record<Variant, React.CSSProperties> = {
  primary: { backgroundColor: colors.accent, color: "white", border: "none" },
  secondary: { backgroundColor: "white", color: colors.text, border: `1px solid ${colors.borderStrong}` },
  danger: { backgroundColor: colors.dangerSoft, color: colors.danger, border: "none" },
  ghost: { backgroundColor: colors.bg, color: colors.text, border: "none" },
};

export function Button({ children, onClick, variant = "secondary", disabled, small, style }: {
  children: React.ReactNode; onClick?: () => void; variant?: Variant; disabled?: boolean; small?: boolean; style?: React.CSSProperties;
}) {
  return (
    <button
      onClick={onClick} disabled={disabled}
      style={{
        display: "inline-flex", alignItems: "center", gap: 6, justifyContent: "center",
        borderRadius: radius.sm, cursor: disabled ? "default" : "pointer", fontWeight: 600,
        padding: small ? "6px 10px" : "10px 16px", fontSize: small ? 12 : 13.5,
        opacity: disabled ? 0.6 : 1, ...VARIANTS[variant], ...style,
      }}
    >
      {children}
    </button>
  );
}

export function SearchInput({ value, onChange, placeholder, width = 260 }: { value: string; onChange: (v: string) => void; placeholder?: string; width?: number }) {
  return (
    <div style={{ position: "relative", width }}>
      <div style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9AA0A8" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>
      </div>
      <input
        value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder || "Rechercher..."}
        style={{ width: "100%", backgroundColor: "white", border: `1px solid ${colors.borderStrong}`, borderRadius: radius.sm, padding: "10px 14px 10px 36px", fontSize: 14, outline: "none", boxSizing: "border-box" }}
      />
    </div>
  );
}
